class ChaseMobileCarousel extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.querySelector('.chase-mobile-carousel__wrapper');
    if (!this.wrapper) return;

    this.onResize = () => {
      this.fitDesktopRow();
      this.updateDragMode();
    };

    this.updateDragMode();
    this.fitDesktopRow();
    window.addEventListener('resize', this.onResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  updateDragMode() {
    if (!this.wrapper) return;
    if (this.isMobile()) {
      if (!this.dragBound) {
        this.setupDragScroll();
        this.dragBound = true;
      }
      this.wrapper.style.transform = '';
    } else {
      this.wrapper.style.transform = '';
    }
  }

  fitDesktopRow() {
    if (!this.wrapper || this.isMobile()) {
      if (this.wrapper) this.wrapper.style.transform = '';
      return;
    }

    this.wrapper.style.transform = '';
    const available = this.clientWidth;
    const needed = this.wrapper.scrollWidth;

    if (needed > available && available > 0) {
      const scale = available / needed;
      this.wrapper.style.transform = `scale(${scale})`;
      this.wrapper.style.transformOrigin = 'center top';
    }
  }

  setupDragScroll() {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    this.wrapper.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - this.wrapper.offsetLeft;
      scrollLeft = this.wrapper.scrollLeft;
    });

    this.wrapper.addEventListener('mouseleave', () => { isDown = false; });
    this.wrapper.addEventListener('mouseup', () => { isDown = false; });

    this.wrapper.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - this.wrapper.offsetLeft;
      this.wrapper.scrollLeft = scrollLeft - (x - startX) * 2;
    });
  }
}

customElements.define('chase-mobile-carousel', ChaseMobileCarousel);

class LytiChaseSearch {
  constructor() {
    this.panel = document.getElementById('LytiChaseSearchPanel');
    this.toggles = document.querySelectorAll('[data-lyti-search-toggle]');
    if (!this.panel || !this.toggles.length) return;

    this.toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.isOpen()) {
          this.close();
        } else {
          this.open();
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!this.isOpen()) return;
      if (event.target.closest('#LytiChaseSearchPanel')) return;
      if (event.target.closest('[data-lyti-search-toggle]')) return;
      this.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isOpen()) this.close();
    });
  }

  isOpen() {
    return this.panel && !this.panel.hidden;
  }

  open() {
    this.panel.hidden = false;
    this.toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
    const input = this.panel.querySelector('input[type="search"]');
    if (input) {
      requestAnimationFrame(() => input.focus({ preventScroll: true }));
    }
  }

  close() {
    this.panel.hidden = true;
    this.toggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
    const predictive = this.panel.querySelector('predictive-search');
    if (predictive && typeof predictive.close === 'function') predictive.close(true);
  }
}

class ChaseQuickAddModal {
  constructor() {
    this.modal = document.getElementById('quick-add-modal-mobile');
    if (!this.modal) return;
    this.bindEvents();
  }

  bindEvents() {
    this.modal.querySelectorAll('[data-close-modal]').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-chase-quick-add]');
      if (!trigger) return;
      e.preventDefault();
      this.open(trigger.dataset);
    });
  }

  open(data) {
    const img = this.modal.querySelector('.product-image');
    const title = this.modal.querySelector('.product-title-modal');
    const container = this.modal.querySelector('.size-options-container');

    if (img) img.src = data.image || '';
    if (title) title.textContent = data.title || '';
    if (container) {
      container.innerHTML = '';
      const sizes = (data.sizes || 'P,M,G').split(',');
      const wrapper = document.createElement('div');
      wrapper.className = 'size-options-mobile';
      sizes.forEach((size) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'size-option-mobile';
        btn.textContent = size.trim();
        btn.addEventListener('click', () => this.addToCart(data.variantId, btn));
        wrapper.appendChild(btn);
      });
      container.appendChild(wrapper);
    }

    this.modal.hidden = false;
    requestAnimationFrame(() => this.modal.classList.add('show'));
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.modal.classList.remove('show');
    document.body.style.overflow = '';
    setTimeout(() => { this.modal.hidden = true; }, 300);
  }

  async addToCart(variantId, btn) {
    if (!variantId) return;
    btn.classList.add('loading');
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      });
      if (res.ok) {
        this.close();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const notif = document.querySelector('cart-notification');
        if (notif) notif.open();
      }
    } finally {
      btn.classList.remove('loading');
    }
  }
}

function isMogiDasCruzes(city) {
  if (!city) return false;
  const normalized = city.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return normalized.includes('mogi') && normalized.includes('cruz');
}

function getLytiShippingConfig() {
  const el = document.getElementById('lyti-shipping-config');
  if (!el) return {};
  try {
    return JSON.parse(el.textContent);
  } catch {
    return {};
  }
}

function applyShippingLabel(el, text, variant) {
  el.textContent = text;
  el.classList.remove(
    'lyti-chase-product-shipping__label--mogi',
    'lyti-chase-product-shipping__label--promo',
    'lyti-chase-product-shipping__label--consultar'
  );
  el.style.color = '';
  el.style.fontWeight = '';
  if (variant) el.classList.add(`lyti-chase-product-shipping__label--${variant}`);
}

function applyLytiShippingLocation() {
  const config = getLytiShippingConfig();
  const mogiFrete = config.mogiFrete || 'Frete fixo R$ 5,00';
  const promoPrefix = config.promoPrefix || 'Promoção imperdível só hoje para:';
  const consultar = config.consultar || 'CONSULTAR';
  const loadingLocation = config.loadingLocation || 'carregando...';

  const targets = document.querySelectorAll('[data-lyti-shipping-location]');
  const shippingLabels = document.querySelectorAll('[data-lyti-shipping-label]');
  const announcements = document.querySelectorAll('.announcement-bar-section .announcement-bar__message');

  const setLocation = (city, region) => {
    const hasCity = Boolean(city && city !== 'sua região');
    const label = hasCity
      ? (region ? `${city} e Região` : city)
      : loadingLocation;
    const mogi = isMogiDasCruzes(city);

    targets.forEach((el) => {
      el.textContent = 'todo o Brasil';
    });

    shippingLabels.forEach((el) => {
       if (mogi) {
        applyShippingLabel(el, '', 'mogi');
      } else if (hasCity) {
        applyShippingLabel(el, '', 'promo');
      } else {
        applyShippingLabel(el, '', 'consultar');
      }
    });

    announcements.forEach((el, index) => {
      return; if (el.dataset.lytiLocationDone) return;
      if (index !== 0) return;

      el.textContent = '';
      if (mogi) {
        el.appendChild(document.createTextNode(`${mogiFrete} para `));
        const cityEl = document.createElement('strong');
        cityEl.textContent = label;
        el.appendChild(cityEl);
      } else if (hasCity) {
        el.appendChild(document.createTextNode(`${promoPrefix} `));
        const cityEl = document.createElement('strong');
        cityEl.textContent = label;
        el.appendChild(cityEl);
      } else {
        el.textContent = consultar;
      }
      el.dataset.lytiLocationDone = 'true';
    });
  };

  const parseWtfismyip = (data) => {
    const raw = data.YourFuckingLocation || data.yourfuckinglocation || '';
    const city = raw.replace(', Brazil', '').replace(', Brasil', '').trim();
    setLocation(city, '');
  };

  fetch('https://wtfismyip.com/json')
    .then((res) => (res.ok ? res.json() : null))
    .then((data) => {
      if (!data) throw new Error('no data');
      parseWtfismyip(data);
    })
    .catch(() => {
      fetch('https://ipapi.co/json/')
        .then((res) => (res.ok ? res.json() : null))
        .then((data) => {
          if (!data) throw new Error('no data');
          setLocation(data.city, data.region);
        })
        .catch(() => setLocation('sua região', ''));
    });
}

function initLytiTrackForms() {
  document.querySelectorAll('[data-lyti-track-form]').forEach((form) => {
    if (form.dataset.lytiTrackBound) return;
    form.dataset.lytiTrackBound = 'true';
    const result = form.closest('.lyti-track-order')?.querySelector('[data-lyti-track-result]');
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const input = form.querySelector('input[name="tracking_code"]');
      if (!input || !input.value.trim()) return;
      if (result) {
        result.hidden = false;
        result.textContent = `Recebemos o código "${input.value.trim()}". Em breve você poderá acompanhar seu pedido por aqui.`;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';
  new LytiChaseSearch();
  new ChaseQuickAddModal();
  applyLytiShippingLocation();
  initLytiTrackForms();
});